import { SettingsState } from '@Features/settings/settingsSlice.types';
import axios from 'axios';
export const fetchSettingsRequest = async () =>
	await axios.get<SettingsState>(
		process.env.REACT_APP_API_URL + '/settings/public'
	);

export const fetchAssetsRequest = async () =>
	await axios.get<ApiResponse<Record<string, string>>>(
		process.env.REACT_APP_API_URL + '/settings/assets'
	);
